module.exports = __webpack_public_path__ + "static/media/sass.44a04cac.svg";